import * as React from "react";
function SvgIcLayoutTall(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 3h18v9H3V3zm1 1v7h16V4H4zm9 9h8v8h-8v-8zm1 1v6h6v-6h-6zM3 13h8v8H3v-8zm1 1v6h6v-6H4z"
        fill="currentColor"
      />
    </svg>
  );
}
export default SvgIcLayoutTall;
